import apiClient, { api } from './apiClient';

// Generic document store (backend `documents` table, polymorphic by
// entity_type + entity_id). One service so any transaction can attach files.

export interface DocMeta {
  id: number;
  file_name: string;
  mime_type: string | null;
  size_bytes: number | null;
  folder: string | null;
  entity_type: string | null;
  entity_id: number | null;
  created_at: string;
}

export const documentsService = {
  list: (entityType: string, entityId: number | string): Promise<{ documents: DocMeta[]; pagination: any }> =>
    api.get('/documents', { params: { entityType, entityId, limit: 100 } }),

  upload: (file: File, entityType: string, entityId: number | string, folder?: string): Promise<{ document: DocMeta }> => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('entityType', entityType);
    fd.append('entityId', String(entityId));
    if (folder) fd.append('folder', folder);
    return api.post('/documents', fd);
  },

  remove: (id: number): Promise<any> => api.delete(`/documents/${id}`),

  // Download streams a file (not JSON) — use the raw client with a blob response
  // so the envelope unwrapper is bypassed, then trigger a browser save.
  download: async (id: number, fileName: string): Promise<void> => {
    const res = await apiClient.get(`/documents/${id}/download`, { responseType: 'blob' });
    const url = URL.createObjectURL(res.data as Blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName || `document-${id}`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  },
};

export default documentsService;
